import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { history } from "../../web/src/logic/store";

const ScrollToTop: React.FC<{}> = (p) => {
	useEffect(() => {
		const unlisten = history.listen(() => {
			window.scrollTo(0, 0);
		});
		return () => {
			unlisten();
		};
	}, []);

	return null;
};

export default withRouter(ScrollToTop);
